import React from "react";
import Toolbar from "@mui/material/Toolbar";
import { useDispatch } from "react-redux";
import { showLoadingScreen } from "../../store/slices/loading";
import {
  Drawer,
  Box,
  TextField,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogContentText,
  DialogActions,
  Stack,
  CircularProgress,
} from "@mui/material";
import {
  Cancel as CancelIcon,
  Send as SendIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import { getCities, savePersona } from "../../services/apiRequests";
import { locStor } from "../../services/localStorageManipulation";
import { USER_APIKEY } from "../../services/constants";
import { useSnackbar } from "notistack";

const drawerWidth = { max: 1000, min: 300 };
const defaultObj = {
  birthDay: null,
};

const NewPersonForm = ({ isOpen, setOpen, setNeedRefreshData }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [newPersonData, setNewPersonData] = React.useState(defaultObj);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [citiesList, setCitiesList] = React.useState([]);
  const [fetchingCities, setFetchingCities] = React.useState(false);
  const [sendingRequest, setSendingRequest] = React.useState(false);

  const jobsList = useSelector((state) => state.jobsList.data);
  const deptosList = useSelector((state) => state.deptosList.data);
  const userData = useSelector((state) => state.userData.data);

  const dispatch = useDispatch();

  const formClose = () => {
    setNewPersonData(defaultObj);
    setOpen(false);
  };
  const registNewPerson = () => {
    setSendingRequest(true);
    const userApiKey = locStor.get(USER_APIKEY);
    savePersona(userApiKey, userData.id, newPersonData).then((data) => {
      if (data.codigo === 200) {
        enqueueSnackbar(data.mensaje, { variant: "success" });
        setNewPersonData(defaultObj);
        modalConfirmation.close();
        setNeedRefreshData();
        dispatch(showLoadingScreen());
      } else {
        enqueueSnackbar("algo salió mal...", { variant: "warning" });
      }
      setSendingRequest(false);
    });
  };
  const valuesHandler = {
    name: (valueP) => {
      setNewPersonData({ ...newPersonData, name: valueP });
    },
    birthDay: (valueP) => {
      const year = valueP.getFullYear();
      const month =
        (String(valueP.getMonth() + 1).length === 2 ? "" : "0") +
        (valueP.getMonth() + 1);
      const day =
        (String(valueP.getDate()).length === 2 ? "" : "0") + valueP.getDate();
      setNewPersonData({
        ...newPersonData,
        birthDayFormatted: year + "-" + month + "-" + day,
        birthDay: valueP,
      });
    },
    job: (valueP) => {
      setNewPersonData({ ...newPersonData, job: valueP });
    },
    dep: (valueP) => {
      setNewPersonData({ ...newPersonData, dep: valueP });
      setFetchingCities(true);
      const userApiKey = locStor.get(USER_APIKEY);
      getCities(userApiKey, userData.id, valueP).then((data) => {
        setFetchingCities(false);
        setCitiesList(data);
      });
    },
    city: (valueP) => {
      setNewPersonData({ ...newPersonData, city: valueP });
    },
  };
  // const handleDateChange = (e, date) => {
  //   valuesHandler.birthDay(date);
  // };
  const modalConfirmation = {
    open: () => {
      setModalOpen(true);
    },
    close: () => {
      setModalOpen(false);
    },
  };
  // React.useEffect(()=>{
  // }, [needRefreshData])

  return (
    <Drawer
      open={isOpen}
      onClose={formClose}
      anchor={"right"}
      sx={{
        maxWidth: drawerWidth.max,
        minWidth: drawerWidth.min,
        width: "90%",
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          maxWidth: drawerWidth.max,
          minWidth: drawerWidth.min,
          width: "90%",
          boxSizing: "border-box",
        },
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" component="h2">
          Persona Censada
        </Typography>
        <IconButton onClick={formClose}>
          <CloseIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <Box
        sx={{
          width: "100%",
          mt: 2,
          px: 2,
        }}
      >
        {/*Nombre */}
        <TextField
          variant="filled"
          color="primary"
          value={newPersonData.name ? newPersonData.name : ""}
          label="Nombre"
          fullWidth
          sx={{ mb: 2 }}
          error={false}
          helperText={false ? "ERROR HERE" : ""}
          onChange={(e) => {
            valuesHandler.name(e.target.value);
          }}
        />

        {/*F. Nac. */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            slotProps={{ textField: { variant: "filled" } }}
            color="primary"
            disableFuture
            label="Fecha de Nacimiento"
            sx={{
              width: "100%",
              mb: 2,
            }}
            format="DD/MM/YYYY"
            onChange={(dateValue) => {
              valuesHandler.birthDay(dateValue.$d);
            }}
            value={newPersonData.birthDay ? newPersonData.birthDay : null}
          />
        </LocalizationProvider>

        {/*Job */}
        <FormControl
          variant="filled"
          color="primary"
          fullWidth
          sx={{
            mb: 2,
          }}
        >
          <InputLabel id="ocupacionLabel">Ocupación</InputLabel>
          <Select
            labelId="ocupacionLabel"
            id="ocupacionInput"
            label="Ocupación"
            value={newPersonData.job ? newPersonData.job : ""}
            onChange={(e) => {
              valuesHandler.job(e.target.value);
            }}
          >
            {jobsList.map((jobItem) => {
              return (
                <MenuItem key={jobItem.id} value={jobItem.id}>
                  {jobItem.ocupacion}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {/*Depto */}
        <FormControl
          variant="filled"
          color="primary"
          fullWidth
          sx={{
            mb: 2,
          }}
        >
          <InputLabel id="depLabel">Departamento</InputLabel>
          <Select
            labelId="depLabel"
            id="depInput"
            label="Departamento"
            value={newPersonData.dep ? newPersonData.dep : ""}
            onChange={(e) => {
              valuesHandler.dep(e.target.value);
            }}
          >
            {deptosList.map((deptoItem) => {
              return (
                <MenuItem key={deptoItem.id} value={deptoItem.id}>
                  {deptoItem.nombre}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {/*Ciudad */}
        <FormControl
          variant="filled"
          color="primary"
          fullWidth
          sx={{
            mb: 2,
          }}
        >
          <InputLabel id="cityLabel">
            {fetchingCities ? (
              <>
                <CircularProgress size={20} /> Cargando...
              </>
            ) : (
              "Ciudad"
            )}
          </InputLabel>
          <Select
            labelId="cityLabel"
            id="cityInput"
            label="Ciudad"
            value={newPersonData.city ? newPersonData.city : ""}
            onChange={(e) => {
              valuesHandler.city(e.target.value);
            }}
            disabled={citiesList.length === 0}
          >
            {citiesList.length !== 0 ? (
              citiesList.map((city) => (
                <MenuItem value={city.id} key={city.id}>
                  {city.nombre}
                </MenuItem>
              ))
            ) : (
              <MenuItem value={""}>Seleccione un departamento</MenuItem>
            )}
          </Select>
        </FormControl>

        <Divider />
        <Button
          variant="outlined"
          fullWidth
          sx={{
            my: 2,
          }}
          endIcon={<CancelIcon />}
          onClick={formClose}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          fullWidth
          endIcon={<SendIcon />}
          onClick={() => {
            // registNewPerson();
            modalConfirmation.open();
          }}
          disabled={
            !(
              newPersonData.name &&
              newPersonData.birthDay &&
              newPersonData.job &&
              newPersonData.dep &&
              newPersonData.city
            )
          }
        >
          Registrar
        </Button>
        <Typography
          variant="body2"
          component="span"
          sx={{ opacity: "0.7", fontStyle: "italic" }}
        >
          Antes de registrar, se deberá confirmar los datos
        </Typography>
      </Box>

      <Dialog
        open={isModalOpen}
        onClose={() => {
          modalConfirmation.close();
        }}
      >
        <DialogTitle>Confirmar Datos de Persona Censada</DialogTitle>
        <Divider />
        <DialogContent>
          {/* <DialogContentText> */}
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{ my: 1 }}
              >
                <Typography sx={{ pr: 12 }}>Nombre:</Typography>
                <Typography variant="h6" component="span">
                  {newPersonData.name ? (
                    newPersonData.name
                  ) : (
                    <i>No especificado</i>
                  )}
                </Typography>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{ my: 1 }}
              >
                <Typography sx={{ pr: 12 }}>F. Nacimiento</Typography>
                <Typography variant="h6" component="span">
                  {newPersonData.birthDayFormatted ? (
                    newPersonData.birthDayFormatted.slice(8, 10) +
                    "/" +
                    newPersonData.birthDayFormatted.slice(5, 7) +
                    "/" +
                    newPersonData.birthDayFormatted.slice(0, 4)
                  ) : (
                    <i>No especificado</i>
                  )}
                </Typography>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{ my: 1 }}
              >
                <Typography sx={{ pr: 12 }}>Ocupación</Typography>
                <Typography variant="h6" component="span">
                  {newPersonData.job ? (
                    jobsList.find((job) => {
                      return job.id === newPersonData.job;
                    }).ocupacion
                  ) : (
                    <i>No especificado</i>
                  )}
                </Typography>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{ my: 1 }}
              >
                <Typography sx={{ pr: 12 }}>Departamento:</Typography>
                <Typography variant="h6" component="span">
                  {newPersonData.dep ? (
                    deptosList.find((depto) => {
                      return depto.id === newPersonData.dep;
                    }).nombre
                  ) : (
                    <i>No especificado</i>
                  )}
                </Typography>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{ my: 1 }}
              >
                <Typography sx={{ pr: 16 }}>Ciudad</Typography>
                <Typography variant="h6" component="span">
                  {newPersonData.city ? (
                    citiesList.find((city) => {
                      return city.id === newPersonData.city;
                    }).nombre
                  ) : (
                    <i>No especificado</i>
                  )}
                </Typography>
              </Stack>
            </Box>
          {/* </DialogContentText> */}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              modalConfirmation.close();
            }}
          >
            Volver
          </Button>
          <Button
            onClick={() => {
              registNewPerson();
            }}
            variant="contained"
            disabled={sendingRequest}
          >
            {(sendingRequest ? <CircularProgress size={20} sx={{color: "rgba(0, 0, 0, 0.5)"}} thickness={10} />: "Confirmar")}

          </Button>
        </DialogActions>
      </Dialog>
    </Drawer>
  );
};

export default NewPersonForm;
